const whatWeDoModules = document.querySelectorAll('.what-we-do');

if (whatWeDoModules.length > 0) {
  whatWeDoModules.forEach((el) => {
    const parentElement = el.closest('.sc-what-we-do');
    const fakeSlideParent = parentElement.querySelector('.what-we-do__faker-slides');
    const totalSlides = fakeSlideParent.getAttribute('data-total-slides');
    const stickyStartPoint = parentElement.querySelector('.what-we-do__sticky-start');
    const entryStartPoint = parentElement.querySelector('.what-we-do__entry-start');
    const fakeSlides = parentElement.querySelectorAll('.what-we-do__faker-main-slide');
    const fakeIntro = parentElement.querySelector('.what-we-do__faker-slide-intro');
    const realSlides = parentElement.querySelectorAll('.what-we-do__slide-main');
    const bullets = parentElement.querySelectorAll('.slider-pagination__bullet');
    const pagination = parentElement.querySelector('.slider-pagination');
    const whatWeDoSliderInit = parentElement.querySelector('.what-we-do__scrollbar');
    const scrollStart = parentElement.querySelector('.what-we-do__scroll-start');
    const parentBody = parentElement.querySelector('.what-we-do__body');
    const sliderNav = parentElement.querySelector('.what-we-do__nav');
    const prevSlideArrow = parentElement.querySelector('.prev-button');
    const nextSlideArrow = parentElement.querySelector('.next-button');

    let controllerWhatWeDoModule = null;
    controllerWhatWeDoModule = new ScrollMagic.Controller();

    // ----
    // Slider
    // ----

    const whatWeDoSliderOptions = {
      slidesPerView: 'auto',
      spaceBetween: 0,
      speed: 800,
      allowTouchMove: false,
      simulateTouch: false,
      direction: 'vertical',
    };

    const whatWeDoSlider = new Swiper(whatWeDoSliderInit, whatWeDoSliderOptions);

    // ----
    // Entry scene
    // ----
    const initEntryScene = () => {
      const scene = new ScrollMagic.Scene({
        triggerElement: entryStartPoint,
        duration: fakeIntro.clientHeight,
        triggerHook: 0,
      })
        .on('enter', () => {
          parentElement.classList.add('is-animated');
        })
        .on('progress', (e) => {
          parentElement.classList.toggle('fade-text', e.progress >= 0.5);
        })
        .addTo(controllerWhatWeDoModule);

      if (isLocal()) {
        scene.addIndicators({ name: 'Main Entry' });
      }
    };

    // ----
    // Sticky scene
    // ----
    const initStickyElementScene = () => {
      const stickyDuration = parseInt(totalSlides, 10) * 1500;
      const scene = new ScrollMagic.Scene({
        triggerElement: stickyStartPoint,
        duration: stickyDuration,
        triggerHook: 0,
      })
        .on('enter', (e) => {
          document.documentElement.style.scrollBehavior = 'inherit';

          if (e.scrollDirection === 'REVERSE') {
            pagination.classList.add('show-pagination');
          }
        })
        .on('leave', (e) => {
          document.documentElement.style.scrollBehavior = 'smooth';

          if (e.scrollDirection === 'FORWARD') {
            pagination.classList.remove('show-pagination');
          }
        })
        .setPin(el)
        .addTo(controllerWhatWeDoModule);

      if (isLocal()) {
        scene.addIndicators({ name: 'Sticky' });
      }
    };

    // ----
    // Move Intro
    // ----
    const moveIntro = () => {
      const scene = new ScrollMagic.Scene({
        triggerElement: scrollStart,
        duration: parseInt(totalSlides, 10) * 1500,
        triggerHook: 0,
      })
        .on('enter', (e) => {
          pagination.classList.add('show-pagination');
          if (e.scrollDirection === 'FORWARD') {
            parentBody.classList.add('move-intro');
            sliderNav.classList.add('is-visible');
            prevSlideArrow.classList.remove('is-disabled');
            nextSlideArrow.classList.remove('is-disabled');
          }
        })
        .on('leave', (e) => {
          pagination.classList.remove('show-pagination');
          if (e.scrollDirection === 'REVERSE') {
            sliderNav.classList.remove('is-visible');
            parentBody.classList.remove('move-intro');
          }
        })
        .addTo(controllerWhatWeDoModule);

      if (isLocal()) {
        scene.addIndicators({ name: 'Move Intro' });
      }
    };

    // ----
    // Each slide entry scene
    // ----
    const slideEntryScene = () => {
      fakeSlides.forEach((el, i) => {
        const scene = new ScrollMagic.Scene({
          triggerElement: el,
          duration: el.clientHeight,
          triggerHook: 0,
        })
          .on('enter', () => {
            whatWeDoSlider.slideTo(i, 800);
            realSlides[i].classList.add('is-animated');
            bullets[i].classList.add('is-active');
            nextSlideArrow.classList.toggle('is-disabled', i === realSlides.length - 1);
          })
          .on('leave', (e) => {
            if (e.scrollDirection === 'FORWARD' && i < bullets.length - 1) {
              bullets[i].classList.remove('is-active');
            }

            if (e.scrollDirection === 'REVERSE') {
              bullets[i].classList.remove('is-active');
            }
          })
          .addTo(controllerWhatWeDoModule);

        if (isLocal()) {
          scene.addIndicators({ name: `slide ${i}` });
        }
      });

      const scrollToSlide = (element, scrollBehavior) => {
        const elementRect = element.getBoundingClientRect();
        const scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
        const topOffset = elementRect.top + scrollTop;
        window.scrollTo({
          top: topOffset,
          behavior: scrollBehavior,
        });
      };

      nextSlideArrow.addEventListener('click', (btn) => {
        const nextIndex = whatWeDoSlider.realIndex + 1;
        if (nextIndex <= realSlides.length - 1) {
          const nextSlide = parentElement.querySelector(`[data-slide="${nextIndex}"]`);
          scrollToSlide(nextSlide, 'instant');
        } else {
          btn.target.classList.add('is-disabled');
        }
      });

      // prevSlideArrow.addEventListener('click', () => {
      //   const prevIndex = whatWeDoSlider.realIndex - 1;

      //   if (prevIndex >= 0) {
      //     const prevSlide = parentElement.querySelector(`[data-slide="${prevIndex}"]`);
      //     scrollToSlide(prevSlide, 'instant');
      //   } else {
      //     parentBody.classList.remove('move-intro');
      //     scrollToSlide(stickyStartPoint, 'smooth');
      //   }
      // });
    };

    // ----
    // Init All scene
    // ----
    const initAllScenes = () => {
      initStickyElementScene();
      initEntryScene();
      moveIntro();
      slideEntryScene();
    };

    // ----
    // Destroy for mobile
    // ----
    const handleResize = () => {
      initializeOrDestroyScrollMagic(controllerWhatWeDoModule, initAllScenes);
    };
    if (windowWidth() >= breakpointMd) {
      initAllScenes();
    }
    window.addEventListener('resize', handleResize);
  });
}
